import { render } from "./TwoColumns.vue?vue&type=template&id=d49153d8"
import script from "./TwoColumns.vue?vue&type=script&lang=js"
export * from "./TwoColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__